import React from "react";
import AttendeeDropdown from "./AttendeeDropdown";
import { RemovableContactLabel } from "components/Removables/RemovableContact";

interface Props {
  attendees: server.dto.ContactSmallV2[]
  onAttendeeRemoved: (attendee: server.dto.ContactSmallV2) => void
  onAttendeeEdited: (attendee: server.dto.ContactSmallV2) => void
  onAttendeeAdded: (attendee: server.dto.ContactSmallV2) => void
  canCreate: boolean
}

const Attendees = (props: Props) => {
  return <>
    <div className="flex-column gap margin-bottom">
      {props.attendees.map(a => (
        <RemovableContactLabel
          key={a.contactId}
          value={a}
          onChange={contact => {
            if (contact == null) {
              props.onAttendeeRemoved(a);
            } else {
              props.onAttendeeEdited(contact);
            }
          }}
          readonly={false}
          error={false}
        />
      ))}
    </div>
    <div>
      <AttendeeDropdown
        excludedContacts={props.attendees.map(a => a.contactId)}
        onContactSelected={props.onAttendeeAdded}
        canCreate={props.canCreate}
      />
    </div>
  </>;
};

export default Attendees;